import httpClient from './httpClient';
import { parseApiError } from '../utils/errorHandler';

const BASE_PATH = '/api/configuracoes';

/**
 * @param {unknown} raw
 * @returns {import('../constants/systemConfiguration').SystemConfiguration | null}
 */
export function normalizeConfiguration(raw) {
    if (!raw || typeof raw !== 'object' || raw.key == null || String(raw.key).trim() === '') {
        return null;
    }
    return {
        key: String(raw.key),
        description: raw.description == null ? '' : String(raw.description),
        type: raw.type == null ? 'STRING' : String(raw.type),
        value: raw.value == null ? '' : String(raw.value),
    };
}

function invalidResponse(status) {
    return {
        message: 'Resposta de configuração inválida.',
        details: [],
        status: status ?? null,
    };
}

/**
 * @param {Response} response
 * @returns {Promise<import('../constants/systemConfiguration').SystemConfiguration>}
 */
async function readConfiguration(response) {
    if (!response.ok) {
        throw await parseApiError(response);
    }
    const json = await response.json();
    const config = normalizeConfiguration(json);
    if (!config) {
        throw invalidResponse(response.status);
    }
    return config;
}

/** @returns {Promise<import('../constants/systemConfiguration').SystemConfiguration[]>} */
async function listConfigurations() {
    const response = await httpClient.get(BASE_PATH);
    if (!response.ok) {
        throw await parseApiError(response);
    }
    const json = await response.json();
    if (!Array.isArray(json)) {
        throw invalidResponse(response.status);
    }
    return json.map(normalizeConfiguration).filter(Boolean);
}

/**
 * @param {string} key
 * @returns {Promise<import('../constants/systemConfiguration').SystemConfiguration>}
 */
async function getConfiguration(key) {
    const response = await httpClient.get(`${BASE_PATH}/${encodeURIComponent(key)}`);
    return readConfiguration(response);
}

/**
 * @param {string} key
 * @param {import('../constants/systemConfiguration').UpdateConfigurationRequest} request
 * @returns {Promise<import('../constants/systemConfiguration').SystemConfiguration>}
 */
async function patchConfiguration(key, request) {
    const value = request?.value == null ? '' : String(request.value);
    const response = await httpClient.patch(
        `${BASE_PATH}/${encodeURIComponent(key)}`,
        { value },
    );
    return readConfiguration(response);
}

const configurationService = {
    listConfigurations,
    getConfiguration,
    patchConfiguration,
};

export default configurationService;
